<template>
  <div>
<div class="securityaudit-style" v-if="isMobile">
  <toppage></toppage>
      <div class="securityaudit-main">
        <div class="mian-header">
          <div class="header-content">
            <h1>安全审计服务</h1>

            <div class="title-header">
             <span @click="tabonchainfn" :class="activename=='onchain' ? 'header-content':'header-nocontent'">
               <img src="../../assets/image/mobile/securityaudit/lianshangjiaoyisuo.png" alt="">
               <span>&nbsp;链上安全审计</span>
             </span>
             <span :class="activename=='pact' ? 'header-content':'header-nocontent'" @click="tabfn">
               <img src="../../assets/image/mobile/securityaudit/wodeheyue.png" alt="">
               <span>合约安全审计</span>
             </span>
            </div>
            <div class="title-main">
               <div v-if="activename=='onchain'">
                       <img
                     src="../../assets/image/mobile/securityaudit/banner1.png"
                     alt=""
                     class="product-img"
                   />
               </div>
               <div v-else>
                   <img
                     src="../../assets/image/mobile/securityaudit/banner3.png"
                     alt=""
                     class="product-img"
                   />
               </div>
             </div>
     
          </div>
        </div>
<div class="main-profession">
  <h1>服务流程</h1>
  <img src="../../assets/image/mobile/securityaudit/liucheng.png" alt="">
  <div class="liucheng-button" id="connectionUs1">
              <span class="connection-us" @click="connectionusfn">联系我们</span>
              <div class="button-mask" v-show="iswechat">
                <div class="mask-main">

                  <div class="main-content">
                    <span>微信公众号</span>
                    <img src="../../assets/image/newhome/securityaudit/wechat.png" alt="">
                  </div>
                  <div class="main-content">
                    <span>微信客服</span>
                    <img src="../../assets/image/newhome/securityaudit/kefucode.png" alt="">
                  </div>
                </div>
                <div class="mask-bottom">
                  <span>扫码关注微信公众号或者添加微信客服</span>
                </div>
              </div>
            </div>
</div>
        <footerpage></footerpage>
      </div>
      <img class="scroll-button" v-if="showButton"  @click="scrollToTop" src="../../assets/image/newhome/huidaodingbu.png" alt="">

</div>
    <div class="securityaudit-style" v-else>
      <full-page :options="options" ref="fullpage">
        <div class="section securityaudit-top  " >
          <div >

            <div class="securityaudit-nav ">
              <navbar classname="businessintroduce" childclassname="serviceprocess"></navbar>
            </div>
            <div class="section-content ">
              <div class="top-title">
                <div class="securityaudit-title">
                  <h1>安全审计服务</h1>
                  
                </div>
                <div class="title-info">
                 
                  <div>
                 <div class="title-header">
                  <span @click="tabonchainfn" :class="activename=='onchain' ? 'header-content':'header-nocontent'">
                    <img src="../../assets/image/newhome/securityaudit/lianshangjiaoyisuo.png" alt="">
                    <span>&nbsp;链上安全审计</span>
                  </span>
                  <span :class="activename=='pact' ? 'header-content':'header-nocontent'" @click="tabfn">
                    <img src="../../assets/image/newhome/securityaudit/wodeheyue.png" alt="">
                    <span>合约安全审计</span>
                  </span>
                 </div>
              <div class="title-main">
                <div v-if="activename=='onchain'">
                        <img
                      src="../../assets/image/newhome/securityaudit/banner1.png"
                      alt=""
                      class="product-img"
                    />
                </div>
                <div v-else>
                    <img
                      src="../../assets/image/newhome/securityaudit/banner3.png"
                      alt=""
                      class="product-img"
                    />
                </div>
              </div>
                  </div>
                 
                </div>
                <div class="title-content">
                  <!-- <img
                      src="../../assets/image/newhome/securityaudit/banner1.png"
                      alt=""
                      class="product-img"
                    /> -->
              <!-- <div class="block">
                <el-carousel :height="bannerHeight + 'px'">
                  <el-carousel-item>
                    <img
                      src="../../assets/image/newhome/securityaudit/banner1.png"
                      alt=""
                      class="product-img"
                    />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img
                      src="../../assets/image/newhome/securityaudit/banner3.png"
                      alt=""
                      class="product-img"
                    />
                  </el-carousel-item>
                 
                </el-carousel>
              </div> -->
            </div>
                <!-- <div class="judiciary-button animated-element1">
                  <span>司法协助</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
     
      
       
        <div class="section securityaudit-profession">
          <div class="profession-content animated-element1" v-show="isprofession">
            <div class="profession-box">
              <div class="profession-main">
                <div class="profession-info  ">

                  <h1>服务流程</h1>
                 
                </div>
            <div class="profession-liucheng">
              <img src="../../assets//image/newhome/securityaudit/liucheng.png" alt="">
              <div class="liucheng-content">
                <span >业务沟通</span>
                <span>项目评估</span>

                <span>支付费用</span>
                <span>安全审计</span>

                <span>出具报告</span>

              </div>
            </div>
            <div class="liucheng-button" id="connectionUs">
              <span class="connection-us" @click="connectionusfn">联系我们</span>
              <div class="button-mask" v-show="iswechat">
                <div class="mask-main">

                  <div class="main-content">
                    <span>微信公众号</span>
                    <img src="../../assets/image/newhome/securityaudit/wechat.png" alt="">
                  </div>
                  <div class="main-content">
                    <span>微信客服</span>
                    <img src="../../assets/image/newhome/securityaudit/kefucode.png" alt="">
                  </div>
                </div>
                <div class="mask-bottom">
                  <span>扫码关注微信公众号或者添加微信客服</span>
                </div>
              </div>
            </div>
              </div>
           
            </div>
            <div class="profession-bottom">
              <newfooter></newfooter>
            </div>
          </div>
        </div>
      </full-page>
      <div></div>
    </div>
  </div>
  </template>
  <script>
  import navbar from "@/components/navbar.vue";
  import newfooter from "@/components/newfooter.vue";
  // import countTo  from 'vue-count-to';
  // import CountUp from "countup"
  import toppage from "@/views/newhome/toppage.vue";
import footerpage from "@/views/newhome/footerpage.vue";
  export default {
    components: {
      navbar,
      newfooter,
      toppage,
    footerpage,
      // countTo 
    },
    data() {
      return {
        deviceType: this.getDeviceType(),
        showButton: false,
      scrollThreshold: 400,
      isMobile: false,
        activename:'onchain',
        // isshebi:false,
        iswechat:false,
        iscorebusiness1:false,
        iscorebusiness2:false,
        isprofession:false,
        screenWidth: 0,
        bannerHeight: 0,
        options: {
          licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
          //是否显示导航，默认为false
          navigation: true,
   afterLoad: this.afterLoad,
   onLeave:this.onLeave,

          //为每个section设置背景色
          // sectionsColor: [
          //     "#41b883",
          //     "#ff5f45",
          //     "#0798ec",
          //     "#fec401",
          //     "#1bcee6",
          //     "#ee1a59",
          //     "#2c3e4f",
          //     "#ba5be9",
          //     "#b4b8ab"
          // ],
        },
      };
    },
    methods: {
      scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
      getDeviceType() {
      return window.innerWidth < 768 ? "手机" : "电脑";
    },
    handleResize() {
      this.deviceType = this.getDeviceType();
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 1199;
    },
      tabonchainfn(){
        this.activename='onchain'
      },
      tabfn(){
        this.activename='pact'
      },
    //   onLeave(index, direction){
    //   console.log(index, direction);
    // },
    connectionusfn(){
      this.iswechat=!this.iswechat
    },
      afterLoad(anchorLink,index) {
        console.log(anchorLink,index);
          console.log("Emitted 'after load' event.")
          //获取body的classname，跟随section滑动刷新
          let a = document.body.className
          console.log(a);
          //在第几页控制相关逻辑
        //   if(a !== 'fp-scroll-mac fp-viewing-0' || a !== 'fp-viewing-0'){
        //     this.isshebi=false
        //   }
  
          if(a !== 'fp-scroll-mac fp-viewing-1' || a !== 'fp-viewing-1'){
            this.isprofession=false
          }
          if (a === 'fp-scroll-mac fp-viewing-1' || a === 'fp-viewing-1') {
            // console.log(eee);
            this.isprofession=true
     
        }
        // else if(a === 'fp-scroll-mac fp-viewing-0' || a === 'fp-viewing-0'){
        //   this.isshebi=true
        // }
        },
  
   
      next() {
        // 向下滚动一页
        this.$refs.fullpage.api.moveSectionUp();
// this.$refs.fullpage.goTo(0);
      },
    },
    // created(){     location.reload()},
    mounted() {
      if (this.deviceType != "手机" && !this.isMobile) {
      this.next();
    }

    if(this.isMobile){

window.addEventListener('scroll', () => {
  this.showButton = window.scrollY > this.scrollThreshold;
});
}
      // 首次加载时,初始化高度
      this.screenWidth = window.innerWidth;
      this.bannerHeight = (450 / 1450) * this.screenWidth;
      // 窗口大小发生改变
      window.onresize = () => {
        this.screenWidth = window.innerWidth;
        this.bannerHeight = (450 / 1450) * this.screenWidth;
      };
      
    document.addEventListener("click", (e) => {
      const connectionus = document.getElementById("connectionUs");
     
      if (connectionus) {
        if (!connectionus.contains(e.target)) {
          this.iswechat = false;
        }
      }
      
    });
    document.addEventListener("click", (e) => {
      const connectionus = document.getElementById("connectionUs1");
     
      if (connectionus) {
        if (!connectionus.contains(e.target)) {
          this.iswechat = false;
        }
      }
      
    });
    },
    created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener('scroll', () => {});

  },
  };
  </script>
  <style>
  .fp-warning,
  .fp-watermark {
    display: none !important;
  }
  </style>
  
  <style lang="scss" scoped>
  @import "@/assets/scss/securityaudit.scss";
  .el-tabs__header { 
        border-bottom: none; 
      } 
  </style>
  